import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { get_pedidos } from '../../../redux/actions/pedidos'; 
import { Link } from 'react-router-dom';
import eyeblue from '../../../images/eyeblue.svg';
import RequestItemsModal from '../RequestItemsModal'; 
import EditIcon from '../../../images/Edit.svg';
import { MdDelete, MdOutlineInsertComment } from "react-icons/md";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";
import { BsDashLg } from "react-icons/bs";
import { ImBlocked } from "react-icons/im";
import Overlay from '../../ui/Overlay'; 
import Paginator from '../../ui/Paginator';
import RequestChecklist from '../RequestChecklist';
import styles from './RequestList.module.css';
import { formatShortDate } from '../../../utils/date';

const RequestList = ({ pedidos, get_pedidos, cantidadPaginas}) => {
  const [mostrarComponente, setMostrarComponente] = useState(false);
  const [selectedPedido, setSelectedPedido] = useState(null);
  const [showCheckList, setShowCheckList] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayMessage, setOverlayMessage] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [selectedFilters, setSelectedFilters] = useState({
    pageSize: 25,
    page: 1,
    estado: 'undefined',
    nroSolicitud: '',
    fechaCreacion: '',
    fechaResolucion: '',
    fechaCreacionDate: '',
    estadoOrder: 'undefined',
    fechaCreacionOrder: 'undefined',
    fechaCreacionDateOrder: 'desc',
    fechaResolucionOrder: 'undefined',
  });
  const handleNroSolicitudChange = (e) => {
    const value = e.target.value;
    setSelectedFilters({ ...selectedFilters, nroSolicitud: value });
  }

  const handleOverlay = (message, confirmation = false) => {
    setOverlayMessage(message);
    setShowConfirmation(confirmation);
    setShowOverlay(true);
  };
  const handleShowItems = (pedido) => {
    setSelectedPedido(pedido);
    setMostrarComponente(true);
  };

  const handleShowCheckList = (pedido) => {
    setSelectedPedido(pedido);
    setShowCheckList(true);
  };
  const handleConfirmCancel = () => {
    setShowOverlay(false);
  };

  useEffect(() => {
    get_pedidos(selectedFilters);
  }, [get_pedidos, selectedFilters]);

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem('idPedido');
    sessionStorage.removeItem('descripcionTaller')
    sessionStorage.removeItem('selectedTaller');
    get_pedidos(selectedFilters)
      .then(() => setLoading(false))
      .catch(error => setLoading(false));
  }, [get_pedidos, selectedFilters]);

  const obtenerAccion = (estado, idPedido, descripcion) => {
    switch (estado) {
      case 'Recibida':
        return( <div><Link to={`/request/${idPedido}`} style={{ color: '#00A09A' }}> <img src={EditIcon} alt="" />  </Link>
         <div style={{ color: "#00A09A", cursor: "pointer" }} onClick={() => handleOverlay('¿Desea cancelar esta solicitud?', true)}>
            <MdDelete size={26} />
          </div>
        </div>)
      
      case 'Rechazado':
        return (
          <div style={{ color: "#00A09A", cursor: "pointer" }} onClick={() => handleOverlay( `Solicitud rechazada por administrador ${descripcion}`)}>
            <MdOutlineInsertComment size={26} />
          </div>
        );
  
      case 'En proceso':
        return (
          <div style={{ color: "#00A09A", cursor: "pointer" }} onClick={() => handleOverlay(`¿Desea cancelar esta solicitud? ${descripcion}`, true)}>
            <MdDelete size={26} />
          </div>
        );
      
      case 'Entregado':
        return (
          <div style={{ color: "#00A09A", cursor: "pointer" }} onClick={() => handleOverlay(`Entregado ${descripcion}`)}>
            <MdOutlineInsertComment size={26} />
          </div>
        );
      case 'Finalizado':
          return (
            <div style={{ color: "#00A09A", cursor: "pointer" }} onClick={() => handleOverlay(`Finalizado ${descripcion}`)}>
              <MdOutlineInsertComment size={26} />
            </div>
          );
      
      case 'Listo para retiro':
        return (
          <div style={{ color: "#00A09A", cursor: "pointer" }} onClick={() => handleOverlay(`Listo para retiro ${descripcion}`)}>
            <MdOutlineInsertComment size={26} />
          </div>
        );
      
      default:
        return (
          <div style={{ color: "#00A09A" }}>
            <ImBlocked size={24} />
          </div>
        );
    }
  };

  const handlePageSize = (e) => {
    const value = parseInt(e.target.value, 10);
    setSelectedFilters({ ...selectedFilters, pageSize: value });
  }

  const handlePageChange = (page) => {
    setSelectedFilters(prevFilters => ({ ...prevFilters, page }));
  };

  const handleStateChange = (e) => {
    const value = e.target.value;
    setSelectedFilters({ ...selectedFilters, estado: value });
  }

  const ESTADOS = {
    undefined: 'Todos',
    'Recibida': 'Recibida',
    'En proceso': 'En proceso',
    'Entregado': 'Entregado',
    'Finalizado':'Finalizado',
    'Listo para retiro': 'Listo para retiro',
    'Rechazado': 'Rechazado',
  };

  const handleSortChange = (filter) => {
    const order = selectedFilters[filter];
    const newOrder = order === 'undefined' ? 'desc' : order === 'desc' ? 'asc' : 'undefined';
    
    setSelectedFilters(prevFilters => {
      const updatedFilters = {
        ...prevFilters,
        estadoOrder: 'undefined',
        fechaCreacionDateOrder: 'undefined',
        fechaCreacionOrder: 'undefined',
        fechaResolucionOrder: 'undefined',
        [filter]: newOrder
      };
      return updatedFilters;
    });
  };
  return (
    <div className={styles.page}>
      <h2>Solicitudes</h2>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          <form className={styles.filters}>
            <label>
              Cant. solicitudes:
              <select
                className={styles.filterSelect}
                name="pageSize" 
                id="pageSize" 
                value={selectedFilters.pageSize}
                onChange={handlePageSize} >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
              </select>
            </label>
          </form>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead className={styles.tableHead}>
                <tr className={styles.tableHeadTitles}>
                  <th className={styles.idCol}>
                    <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>ID</span>
                    <input
                      type="text"
                      placeholder="ID"
                      className={`${styles.filterInput} ${styles.idInput}`}
                      name="nroSolicitud"
                      id="nroSolicitud"
                      value={selectedFilters.nroSolicitud}
                      onChange={handleNroSolicitudChange}
                    />
                  </th>
                  <th onClick={() => handleSortChange('estadoOrder')} className={styles.sortable}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Estado</span>
                      {selectedFilters.estadoOrder === 'undefined' ? <BsDashLg/> : selectedFilters.estadoOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <select
                      className={styles.filterSelect}
                      name="estado" 
                      id="estado" 
                      value={selectedFilters.estado}
                      onClick={(e) => e.stopPropagation()}
                      onChange={handleStateChange} >
                        {Object.keys(ESTADOS).map(key => (
                          <option key={key} value={key === '' ? undefined : key}>
                            {ESTADOS[key]}
                          </option>
                        ))}
                    </select>
                  </th>
                  <th>Ítems</th>
                  <th onClick={() => handleSortChange('fechaCreacionDateOrder')} className={styles.sortable}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Creación</span>
                      {selectedFilters.fechaCreacionDateOrder === 'undefined' ? <BsDashLg/> : selectedFilters.fechaCreacionDateOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <input
                      type="date"
                      name="fechaCreacionDate"
                      id="fechaCreacionDate"
                      className={`${styles.filterInput} ${styles.requestDateInput}`}
                      value={selectedFilters.fechaCreacionDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({ ...selectedFilters, fechaCreacionDate: e.target.value });
                      }}
                    />
                  </th>
                  <th onClick={() => handleSortChange('fechaCreacionOrder')} className={styles.sortable}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Retiro</span>
                      {selectedFilters.fechaCreacionOrder === 'undefined' ? <BsDashLg/> : selectedFilters.fechaCreacionOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <input
                      type="date"
                      name="fechaCreacion"
                      id="fechaCreacion"
                      className={`${styles.filterInput} ${styles.pickupDateInput}`}
                      value={selectedFilters.fechaCreacion}
                      onChange={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({ ...selectedFilters, fechaCreacion: e.target.value });
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </th>
                  <th onClick={() => handleSortChange('fechaResolucionOrder')} className={styles.sortable}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>Devolución</span>
                      {selectedFilters.fechaResolucionOrder === 'undefined' ? <BsDashLg/> : selectedFilters.fechaResolucionOrder === 'desc' ? <FaArrowDown/> : <FaArrowUp/>}
                    </div>
                    <input
                      type="date"
                      name="fechaResolucion"
                      id="fechaResolucion"
                      className={`${styles.filterInput} ${styles.returnDateInput}`}
                      value={selectedFilters.fechaResolucion}
                      onChange={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({ ...selectedFilters, fechaResolucion: e.target.value });
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody className={styles.tableBody}>
                {pedidos && pedidos.length > 0 && pedidos.map((pedido) => {
                  return (
                    <tr key={pedido.id}>
                      <td>{pedido.id}</td>
                      <td>{pedido.estado}</td>
                      <td>{pedido.items} <img src={eyeblue} alt='icon-eye-blue' id='Ojito' onClick={() => handleShowItems(pedido)} /> </td>
                      <td>{formatShortDate(pedido.pedido_creation_date)}</td>
                      <td>{formatShortDate(pedido.fecha_creacion)}</td>
                      <td>{formatShortDate(pedido.fecha_resolucion)}</td>
                      <td>{obtenerAccion(pedido.estado, pedido.id, pedido.descripcion)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Paginator 
        currentPage={selectedFilters.page} 
        handlePageChange={handlePageChange} 
        totalPageCount={cantidadPaginas} 
      />
        </>
      )}
       {showOverlay && <Overlay message={overlayMessage} onClose={() => setShowOverlay(false)} showConfirmation={showConfirmation} onConfirm={handleConfirmCancel} />}
       {mostrarComponente && <RequestItemsModal onClose={() => setMostrarComponente(false)} pedido={selectedPedido} handleShowCheckList={handleShowCheckList} />}
       {showCheckList && (
        <RequestChecklist
          mostrarCheckList={showCheckList}
          setMostrarCheckList={setShowCheckList}
          solicitud={selectedPedido}
        />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
  pedidos: state.Pedidos.pedidosUsuario,
  cantidadPaginas: state.Pedidos.totalPaginas
});

export default connect(mapStateToProps, { get_pedidos })(RequestList);
